module.exports = __webpack_public_path__ + "img/6.611391f0.png";